//
// Language util
// -------------

define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var config = require('config');

    var allowedLocales = (function(locales) {
        // fix empty allowed locales
        if (locales.length === 1 && locales[0] === '') {
            locales = [config.get('defaultLocale')];
        }

        return typeof locales === 'string' ? locales.split(',') : locales;
    })(config.get('allowedLocales'));

    module.exports = {

        NGMLocalesMapping: {
            'ZH': 'zh-cn',
            'ZH_CN': 'zh-cn'
        },

        /**
         * Application default locale
         * @type {string}
         */
        defaultLocale: config.get('defaultLocale'),

        /**
         * Allowed locales for user
         * @type {Array}
         */
        allowedLocales: allowedLocales,

        /**
         * Map with aliases for allowe locales
         * @type {[type]}
         */
        aliasLocaleMapping: _.pick(config.get('aliasLocaleMapping'), allowedLocales),

        /**
         * Map with compliance languages of app and IMS
         * @type {Object}
         */
        imsLocalesMapping: _.pick({
            at_AT: 'de-at',
            ca_CA: 'en-ca',
            en_AU: 'en-au',
            en_CA: 'en-ca',
            en_GB: 'en-gb',
            es_MX: 'es-mx',
            fr_QC: 'fr-ca',
            jp_JP: 'ja',
            pt_BR: 'pt-br',
            za_ZA: 'en-za',
            zh_CN: 'zh-cn',
            zh_TW: 'zh-tw'
        }, allowedLocales),

        /**
         * Map with shortened locales
         * @type {Object}
         */
        shortLocalesMapping: (function() {
            var shortLocales = {};

            allowedLocales.forEach(function(locale) {
                var parts = locale.split(/[-_]/);

                shortLocales[locale] = _.invert(shortLocales)[parts[0]] ? locale : parts[0];
            });

            return shortLocales;
        })(),

        /**
         * Get allowed locale from any locale type
         * @param  {string} lang
         * @return {string}
         */
        getLanguage: function(lang) {
            var result;

            if (!lang) {
                return null;
            }

            if (lang.length === 2) {
                lang = lang.toLowerCase();
            }

            lang = lang.replace('-', '_');
            var lowerCaseLang = lang.toLowerCase();

            result = _.find(allowedLocales, function(allowed) {
                    return allowed.toLowerCase() === lowerCaseLang;
                })
                || this.getLanguageForAlias(lang)
                || _.invert(this.shortLocalesMapping)[lang] // Shortened version of allowed lang
                || _.invert(this.imsLocalesMapping)[lang] // Convert lang from IMS lang
                || null;

            return result;
        },

        /**
         * Get lang from alias locale mapping
         * @param  {string} lang
         * @return {string}
         */
        getAliasForLanguage: function(lang) {
            return this.aliasLocaleMapping[lang] || lang;
        },

        /**
         * Get lang from alias locale mapping
         * @param  {string} alias
         * @return {string|Undefined}
         */
        getLanguageForAlias: function(alias) {
            return _.invert(this.aliasLocaleMapping)[alias];
        },

        /**
         * Get lang from short locale mapping
         * @param  {string} lang
         * @return {string}
         */
        getShortLanguage: function(lang) {
            return this.shortLocalesMapping[lang];
        },

        /**
         * Get simply shortened lang
         * Consist of first 2 symbols of allowed locale
         * @param  {string} lang
         * @return {string}
         */
        getTwoLetterLanguage: function(lang) {
            lang = this.getLanguage(lang);
            return lang && lang.slice(0, 2) || null;
        },

        getNGMLanguage: function(lang) {
            return this.NGMLocalesMapping[String(lang).toUpperCase()] || this.getTwoLetterLanguage(lang);
        },

        /**
         * Convert lang or shortened lang to IMS lang
         * @param  {string} lang
         * @return {string}
         */
        convertToIMS: function(lang) {
            // Check is lang exist in any mapping
            // and get default locale if there is not
            if (!this.allowedLocales.includes(lang)) {
                lang = _.invert(this.shortLocalesMapping)[lang];
            }

            return this.imsLocalesMapping[lang] || this.getTwoLetterLanguage(lang);
        },

        /**
         * Convert IMS lang to allowed
         * @param  {string} lang
         * @return {string}
         */
        convertFromIMS: function(lang) {
            return _.invert(this.imsLocalesMapping)[lang] ? _.invert(this.imsLocalesMapping)[lang] : this.defaultLocale;
        }

    };
});
